import React from "react";
import "./deathDashboard.css";
import AudioImage from "../../assets/images/DeathModuleNew/headphone-fill.png";
import VideoImage from "../../assets/images/DeathModuleNew/video.png";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import dotIcon from "../../assets/images/DeathModuleNew/dotIcon.png";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const AudioVideoDashboard = (props) => {
  return (
    <div>
      <div
        className="cardHeading"
        style={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        Audio & Video Message
        <ToolTipCreator name={"Death_Audio_Video_Messages"}/>
      </div>
        <div className="uploadButtons" style={{ width: "20px" }}>
          {" "}
          <div className="upload" style={{ width: "20px", height: "20px" }}>
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div
        className="cardDesc"
        style={{ marginTop: "8px", marginBottom: "8px" }}
      >
        Create Audio and/or Video messages for Friends, Family and Spouses with
        this module. A great way to leave a very personal message to the people
        you love.
      </div>

      {props.role !== "trustee" ? (
        <React.Fragment>
        </React.Fragment>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "700",
            fontFamily: "Poppins",
            fontSize: "14px",
            flexDirection: "column",
          }}
        >
          This information will be available to you soon!
          <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop: "8px" }}
            alt="protectedImg"
          ></img>
        </div>
      )}
    </div>
  );
};
